import { GaugeChartMode, GaugeChartSpec, UnitOptions } from '../../../core';
import { OptionsEditorProps } from '../../../plugin-system';

export const DEFAULT_MODE: GaugeChartMode = 'Gauge';
export const DEFAULT_UNIT: UnitOptions = { kind: 'PercentDecimal' };
export const DEFAULT_MAX_PERCENT = 100;
export const DEFAULT_MAX_PERCENT_DECIMAL = 1;

export type GaugeChartOptionsEditorProps = OptionsEditorProps<GaugeChartSpec>;

/**
 * Creates the initial/empty options for a GaugeChart panel.
 */
export function createInitialGaugeChartSpec(): GaugeChartSpec {
  return {
    unit: DEFAULT_UNIT,
    thresholds: {
      steps: [
        {
          value: 0.8,
        },
        {
          value: 0.9,
        },
      ],
    },
  };
}
